import {
  useMutation,
  useQueryClient,
  UseMutationResult,
  UseMutationOptions,
} from "@tanstack/react-query"
import { guardAppUsage } from "@mimber-client/guards/AppGuard"
import { useServerContext } from "@mimber-client/contexts/ServerContext"
import type { EventRefundRequestDto, ResponseDto } from "@mimber/schema"
import { eventRefundsKeys } from "../events.utils"

export const useProcessRefundRequest = (
  eventUuid: string,
  options?: UseMutationOptions<
    ResponseDto<EventRefundRequestDto>,
    Error,
    string
  >
): UseMutationResult<ResponseDto<EventRefundRequestDto>, Error, string> => {
  guardAppUsage("mimber-organization", "useProcessRefundRequest")

  const { server } = useServerContext()
  const queryClient = useQueryClient()

  return useMutation({
    ...options,
    mutationFn: async (refundUuid: string) => {
      const response = await server.post<ResponseDto<EventRefundRequestDto>>(
        `events/${eventUuid}/refunds/${refundUuid}/process`
      )
      return response.data
    },
    onSuccess: (data, variables, onMutateResult, context) => {
      queryClient.invalidateQueries({
        queryKey: eventRefundsKeys.findAll(eventUuid),
      })
      queryClient.invalidateQueries({
        queryKey: eventRefundsKeys.findOne(eventUuid, variables),
      })
      options?.onSuccess?.(data, variables, onMutateResult, context)
    },
  })
}
